import { render, staticRenderFns } from "./sdproduct5.vue?vue&type=template&id=4cec8776&scoped=true"
import script from "./sdproduct5.vue?vue&type=script&lang=js"
export * from "./sdproduct5.vue?vue&type=script&lang=js"
import style0 from "./sdproduct5.vue?vue&type=style&index=0&id=4cec8776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cec8776",
  null
  
)

export default component.exports